import { api } from './apiService';

// Create Stripe checkout session
export const createCheckoutSession = async (packageData) => {
    
    try {
        const requestData = {
            packageId: packageData.id,
            credits: packageData.credits,
            amount: packageData.price
        };
        
        
        const response = await api.post('/payment/create-checkout-session', requestData);
        
        return response.data;
    } catch (error) {
        console.error('❌ Error creating checkout session:', error);
        throw error;
    }
};

// Get payment status
export const getPaymentStatus = async (sessionId) => {
    
    try {
        const response = await api.get(`/payment/status/${sessionId}`);
        return response.data;
    } catch (error) {
        console.error('❌ Error getting payment status:', error);
        throw error;
    }
};

// Process payment success
export const processPaymentSuccess = async (paymentData) => {
    
    try {
        const response = await api.post('/payment/success', paymentData);
        return response.data;
    } catch (error) {
        console.error('❌ Error processing payment success:', error);
        throw error;
    }
};

// Redirect to Stripe checkout
export const redirectToCheckout = (checkoutUrl) => {
    window.location.href = checkoutUrl;
}; 